import { Outlet } from "react-router-dom";
export default function OnboardingLayout() {
  return (
    <div className="vh-100 vw-100 bg-white justify-content-center align-items-center">
      <Outlet />
    </div>
  );
}
